export default __webpack_public_path__ + "static/media/trener10.1c6d0cff.png";